<template>
	<div class="xs-12">
		<form @submit.prevent="onSubmit">
			<div class="stripe-card">
				<div ref="card">
					<!-- A Stripe Element will be inserted here. -->
				</div>
			</div>
		</form>

		<!-- Display error message here -->
		<div class="cError mt2 fs3" v-if="errorMessage">{{ errorMessage }}</div>
	</div>
</template>

<script>
// Create a Stripe client.
let stripe = null
let card = null

export default {
	name: "stripe-payment",
	props: {
		watchSubmit: {
			type: Number,
			required: false,
			default: 0
		},
		stripePublishableKey: {
			type: String,
			required: true
		}
	},

	data() {
		return {
			errorMessage: null
		}
	},

	methods: {
		async onSubmit() {
			this.errorMessage = null
			this.$emit("loading:start")

			let { token, error } = await stripe.createToken(card)
			if (error) this.errorMessage = error.message

			this.$emit("input", {
				isValid: error ? false : true,
				paymentToken: token
			})

			this.$emit("loading:end")
		},

		async loadStripeScript() {
			return new Promise(resolve => {
				let script = document.createElement("script")
				script.setAttribute("src", "https://js.stripe.com/v3/")
				document.head.appendChild(script)

				script.onload = () => resolve(true)
			})
		}
	},

	async mounted() {
		this.$emit("loading:start")
		await this.loadStripeScript()
		this.$emit("loading:end")

		stripe = Stripe(this.stripePublishableKey)

		// Create an instance of Elements.
		let elements = stripe.elements({
			locale: "auto"
		})

		// TODO: this has to be changed manually as Stripe uses css-in-js approach
		// Can we pass css variables there?
		const style = {
			base: {
				fontSize: "1rem",
				color: "#111319",
				fontFamily: `var(--fontFamily1)`
			}
		}

		// Create an instance of the card Element.
		card = elements.create("card", { hidePostalCode: true, style })

		// Add an instance of the card Element into the `card` <div>.
		card.mount(this.$refs.card)
	},

	watch: {
		watchSubmit: {
			handler() {
				this.onSubmit()
			},
			immediate: false
		}
	}
}
</script>

<style>
.StripeElement {
	width: 100%;
	background-color: var(--color4-light-4);
	height: 40px;
	padding: 10px 12px;
	overflow: hidden;
}
</style>
